import {useEffect} from 'react';

export default function Crisp() {
  useEffect(() => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = 'd3c889eb-8d88-4a89-bb96-53bf4f056532';
    (() => {
      const d = document;
      const s = d.createElement('script');
      s.src = 'https://client.crisp.chat/l.js';
      s.async = 1;
      d.getElementsByTagName('body')[0].appendChild(s);
    })();
  });

  return null;
}
